/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FromStatusEnum } from './FromStatusEnum';
import {
    FromStatusEnumFromJSON,
    FromStatusEnumFromJSONTyped,
    FromStatusEnumToJSON,
    FromStatusEnumToJSONTyped,
} from './FromStatusEnum';
import type { ToStatusEnum } from './ToStatusEnum';
import {
    ToStatusEnumFromJSON,
    ToStatusEnumFromJSONTyped,
    ToStatusEnumToJSON,
    ToStatusEnumToJSONTyped,
} from './ToStatusEnum';
import type { TransitionTypeEnum } from './TransitionTypeEnum';
import {
    TransitionTypeEnumFromJSON,
    TransitionTypeEnumFromJSONTyped,
    TransitionTypeEnumToJSON,
    TransitionTypeEnumToJSONTyped,
} from './TransitionTypeEnum';

/**
 * Create and update a transition.
 * 
 * Enforces the rules the admin form enforces: a manual transition cannot carry a condition,
 * from and to status must differ, and the (workflow, from, to) triple is unique. The model
 * raises for the second of those in ``save()``, which would surface as a 500.
 * @export
 * @interface PatchedTransitionWriteRequest
 */
export interface PatchedTransitionWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedTransitionWriteRequest
     */
    workflow?: string;
    /**
     * 
     * @type {FromStatusEnum}
     * @memberof PatchedTransitionWriteRequest
     */
    fromStatus?: FromStatusEnum;
    /**
     * 
     * @type {ToStatusEnum}
     * @memberof PatchedTransitionWriteRequest
     */
    toStatus?: ToStatusEnum;
    /**
     * 
     * @type {TransitionTypeEnum}
     * @memberof PatchedTransitionWriteRequest
     */
    transitionType?: TransitionTypeEnum;
    /**
     * Priority of the transition. Higher number means higher priority.
     * @type {number}
     * @memberof PatchedTransitionWriteRequest
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedTransitionWriteRequest
     */
    condition?: string | null;
}



/**
 * Check if a given object implements the PatchedTransitionWriteRequest interface.
 */
export function instanceOfPatchedTransitionWriteRequest(value: object): value is PatchedTransitionWriteRequest {
    return true;
}

export function PatchedTransitionWriteRequestFromJSON(json: any): PatchedTransitionWriteRequest {
    return PatchedTransitionWriteRequestFromJSONTyped(json, false);
}

export function PatchedTransitionWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTransitionWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflow': json['workflow'] == null ? undefined : json['workflow'],
        'fromStatus': json['from_status'] == null ? undefined : FromStatusEnumFromJSON(json['from_status']),
        'toStatus': json['to_status'] == null ? undefined : ToStatusEnumFromJSON(json['to_status']),
        'transitionType': json['transition_type'] == null ? undefined : TransitionTypeEnumFromJSON(json['transition_type']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'condition': json['condition'] === undefined ? undefined : json['condition'] === null ? null : json['condition'],
    };
}

export function PatchedTransitionWriteRequestToJSON(json: any): PatchedTransitionWriteRequest {
    return PatchedTransitionWriteRequestToJSONTyped(json, false);
}

export function PatchedTransitionWriteRequestToJSONTyped(value?: PatchedTransitionWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflow': value['workflow'],
        'from_status': FromStatusEnumToJSON(value['fromStatus']),
        'to_status': ToStatusEnumToJSON(value['toStatus']),
        'transition_type': TransitionTypeEnumToJSON(value['transitionType']),
        'priority': value['priority'],
        'condition': value['condition'],
    };
}

